
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19677.752 -24590.066 19.504 20.316"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_6960","data-name":"Group 6960","transform":"translate(-21077 -24616)","opacity":".74"}},[_c('ellipse',{staticClass:"cls-2",attrs:{"id":"ellipse","cx":"2.721","cy":"2.615","rx":"2.721","ry":"2.615","transform":"translate(1406.29 33.644)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"path","d":"M18.436 13.307A7.735 7.735 0 0 0 18.844 11a6.531 6.531 0 0 0-.408-2.31l1.406-.959a.411.411 0 0 0 .091-.61l-2.087-2.836a.449.449 0 0 0-.635-.087l-1.451.959a7.212 7.212 0 0 0-2.449-1.264V2.149c0-.436-.091-.51-.363-.51H9.319c-.272 0-.408-.053-.544.51v1.744a7.212 7.212 0 0 0-2.449 1.264l-1.542-1a.4.4 0 0 0-.59.087L2.108 7.118a.419.419 0 0 0 .136.61l1.542 1.046A7.152 7.152 0 0 0 3.423 11a6.773 6.773 0 0 0 .408 2.354l-1.406.959a.411.411 0 0 0-.091.61l2.086 2.833a.449.449 0 0 0 .635.087l1.361-.959a7.409 7.409 0 0 0 2.358 1.177v1.656c0 .262.317.741.544.741h3.628c.272 0 .363-.479.363-.741v-1.659a8.228 8.228 0 0 0 2.495-1.22l1.315.872a.493.493 0 0 0 .635-.087l2.086-2.877a.449.449 0 0 0-.091-.61z","transform":"translate(1397.969 25.044)"}})])])
          )
        }
      }
    